import React from "react";

import Main from "../layouts/main";

export default function(props) {
  return (
    <Main title="Our Plans" subTitle="Best calling plans in the world!" {...props}>
      <h2>Premium calling features</h2>
      <p>
        All monthly calling plans include great features such as VoiceMail, call waiting, caller ID,
        3-way calling, and call forwarding -- at no extra charge. VoiceLine-to-VoiceLine calls are
        also free.
      </p>
      <h2>Pay-As-You-Go calling plan</h2>
      <p>
        If a monthly calling plan isn't right for you, you can choose a Pay-As-You-Go plan. With
        Pay-As-You-Go, you pay per-minute rates for all of your inbound and outbound calls. Simply
        add funds to open your VoiceLine account and make calls.
      </p>
      <ul>
        <li>Inbound calls with a U.S. or Canada phone number are 2.9¢ a minute</li>
        <li>Inbound calls with a toll-free number are 5¢ a minute</li>
        <li>VoiceLine-to-VoiceLine calls are FREE</li>
        <li>VoiceMail is 99¢ a month and all other calling features are FREE</li>
        <li>Lots of Plans to choose from (Customized Plans Available: Ask Us Today)</li>
        <li>
          US/CA Toll Free Numbers with special plans offering Great Savings and Excellent Web
          Presence
        </li>
        <li>Free US Tel Numbers any state available</li>
      </ul>
      <p>
        Ready to sign up?
        <br /> Start by choosing the calling plan thats right for you...
      </p>
      <h2>Calling Plans:</h2>
      <table width="100%" border="0" cellSpacing="1" cellPadding="3">
        <tbody>
          <tr>
            <th width="36%">Plan Name</th>
            <th align="middle" width="46%">
              Plan Includes
            </th>
            <th align="middle" width="18%">
              Monthly Fee
            </th>
          </tr>
          <tr valign="top">
            <td width="36%">U.S./Canada Unlimited  Special</td>
            <td align="middle" width="46%">
              <p>
                Unlimited minutes to.
                <br />
                 U.S. and Canada /PR/USVI/CH/HK/ India
              </p>
              <p>Cell &amp; Land</p>
              <p>Also Land Only UK/FR/SP/IT/NLD/GR</p>
              <p>Free Bonus 100 Min Netherlands Antilles Cell or Land</p>
            </td>
            <td align="middle" width="18%">
              <p>$34.99</p>
              <p>(Without India $29.99)</p>
              <p> </p>
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">U.S./Canada 500</td>
            <td align="middle" width="46%">
              500 minutes to.
              <br /> the U.S. and Canada
            </td>
            <td align="middle" width="18%">
              $14.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">U.S./Canada 300</td>
            <td align="middle" width="46%">
              300 minutes to
              <br /> the U.S. and Canada
            </td>
            <td align="middle" width="18%">
              $9.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Europe 350</td>
            <td align="middle" width="46%">
              350 minutes to
              <br /> Europe, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $14.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Europe 500</td>
            <td align="middle" width="46%">
              500 minutes to
              <br /> Europe, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $19.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Europe Unlimited</td>
            <td align="middle" width="46%">
              Unlimited minutes to
              <br /> Europe, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $39.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">U.K./France Unlimited</td>
            <td align="middle" width="46%">
              Unlimited minutes to the U.K.,
              <br /> France, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $34.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">U.S./Canada Unlimited and Brazil 250</td>
            <td align="middle" width="46%">
              Unlimited minutes to the U.S.
              <br /> and Canada and 250 minutes to Brazil (Land Line)
            </td>
            <td align="middle" width="18%">
              $39.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">U.S./Canada Unlimited and Brazil 500</td>
            <td align="middle" width="46%">
              Unlimited minutes to the U.S.
              <br /> and Canada and 500 minutes to Brazil (Land Line)
            </td>
            <td align="middle" width="18%">
              $44.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">U.S., Canada and Brazil Unlimited</td>
            <td align="middle" width="46%">
              Unlimited minutes to U.S.,
              <br /> Canada and Brazil (Land Line)
            </td>
            <td align="middle" width="18%">
              $54.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Asia 350</td>
            <td align="middle" width="46%">
              350 minutes to
              <br /> Asia, Europe, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $19.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Asia 500</td>
            <td align="middle" width="46%">
              500 minutes to
              <br /> Asia, Europe, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $24.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">China/Hong Kong Unlimited</td>
            <td align="middle" width="46%">
              Unlimited minutes to
              <br /> China, Hong Kong, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $34.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Israel 350 </td>
            <td align="middle" width="46%">
              350 minutes to
              <br /> Israel, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $14.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">Israel 500</td>
            <td align="middle" width="46%">
              500 minutes to
              <br /> Israel, U.S., and Canada
            </td>
            <td align="middle" width="18%">
              $19.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">India 150</td>
            <td align="middle" width="46%">
              150 minutes to India
            </td>
            <td align="middle" width="18%">
              $29.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">India 250</td>
            <td align="middle" width="46%">
              250 minutes to India
            </td>
            <td align="middle" width="18%">
              $44.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">India 500</td>
            <td align="middle" width="46%">
              500 minutes to India
            </td>
            <td align="middle" width="18%">
              $84.99
            </td>
          </tr>
          <tr valign="top">
            <td width="36%">VoiceLine Basic</td>
            <td align="middle" width="46%">
              Per-minute rates for all calls
            </td>
            <td align="middle" width="18%">
              $8.99
            </td>
          </tr>
        </tbody>
      </table>
      <h2>U.S. Voicemail Access Numbers:</h2>
      <table>
        <tbody>
          <tr>
            <th>State</th>
            <th>Phone Number / City</th>
          </tr>
          <tr>
            <td>Alabama</td>
            <td>(205) 453-4040 Birmingham</td>
          </tr>
          <tr>
            <td>Arkansas</td>
            <td>(501) 588-4600 Little Rock</td>
          </tr>
          <tr>
            <td>California</td>
            <td>
              (510) 725-4040 Oakland
              <br /> (213) 233-3535 Los Angeles
              <br /> (415) 692-4040 San Francisco
              <br /> (619) 819-2828 San Diego
              <br /> (408) 914-2600 San Jose
            </td>
          </tr>
          <tr>
            <td>Colorado</td>
            <td>(303) 954-4900 Denver</td>
          </tr>
          <tr>
            <td>Connecticut</td>
            <td>(860) 331-8484 Hartford</td>
          </tr>
          <tr>
            <td>District of Columbia</td>
            <td>(202) 558-4600 Washington</td>
          </tr>
          <tr>
            <td>Florida</td>
            <td>
              (561) 910-4980 Boca Raton
              <br /> (954) 246-3777 Fort Lauderdale
              <br /> (305) 396-2345 Miami
              <br /> (786) 866-6464 Miami
              <br /> (407) 209-3131 Orlando
            </td>
          </tr>
          <tr>
            <td>Georgia</td>
            <td>(678) 608-0480 Atlanta</td>
          </tr>
          <tr>
            <td>Idaho</td>
            <td>(208) 932-4400 Idaho Falls</td>
          </tr>
          <tr>
            <td>Illinois</td>
            <td>(312) 924-0900 Chicago</td>
          </tr>
          <tr>
            <td>Indiana</td>
            <td>(317) 225-5555 Indianapolis</td>
          </tr>
          <tr>
            <td>Kentucky</td>
            <td>(502) 526-4400 Louisville</td>
          </tr>
          <tr>
            <td>Louisiana</td>
            <td>(504) 717-2800 New Orleans</td>
          </tr>
          <tr>
            <td>Maryland</td>
            <td>
              (443) 957-4600 Baltimore
              <br /> (301) 637-4646 Rockville
            </td>
          </tr>
          <tr>
            <td>Massachusetts</td>
            <td>
              (617) 275-5600 Boston
              <br /> (413) 306-4600 Springfield
            </td>
          </tr>
          <tr>
            <td>Michigan</td>
            <td>(313) 263-4100 Detroit</td>
          </tr>
          <tr>
            <td>Missouri</td>
            <td>
              (816) 256-8800 Kansas City
              <br /> (314) 732-4600 St. Louis
            </td>
          </tr>
          <tr>
            <td>Montana</td>
            <td>(406) 545-4400 Billings</td>
          </tr>
          <tr>
            <td>New Jersey</td>
            <td>(201) 716-2121 Jersey City (973) 854-2828 Newark</td>
          </tr>
          <tr>
            <td>New York</td>
            <td>
              (716) 200-1300 Buffalo
              <br /> (646) 432-4444 New York
              <br /> (845) 234-4400 Newburgh
              <br /> (914) 595-5500 Westchester Cty.
            </td>
          </tr>
          <tr>
            <td>Ohio</td>
            <td>
              (513) 373-4949 Cincinnati
              <br /> (216) 539-4600 Cleveland
              <br /> (614) 364-4600 Columbus
            </td>
          </tr>
          <tr>
            <td>Oregon</td>
            <td>(503) 608-4040 Beaverton</td>
          </tr>
          <tr>
            <td>Pennsylvania</td>
            <td>
              (215) 825-7575 Philadelphia
              <br /> (267) 765-0499 Philadelphia (412) 894-8080 Pittsburgh
              <br /> (814) 753-4200 State College
            </td>
          </tr>
          <tr>
            <td>Tennessee</td>
            <td>(901) 457-4400 Memphis</td>
          </tr>
          <tr>
            <td>Texas</td>
            <td>
              (972) 200-4100 Dallas
              <br /> (817) 380-4700 Ft. Worth
              <br /> (281) 816-4333 Houston
              <br /> (832) 495-4950 Houston
            </td>
          </tr>
          <tr>
            <td>Washington</td>
            <td>
              (425) 223-4900 Bellevue
              <br /> (206) 388-4920 Seattle
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Canada Voicemail Access Numbers:</h2>
      <table>
        <tbody>
          <tr>
            <th>State</th>
            <th>Phone Number / City</th>
          </tr>
          <tr>
            <td>Province</td>
            <td>Phone Number / City</td>
          </tr>
          <tr>
            <td>Alberta</td>
            <td>(403) 770-6666 Calgary</td>
          </tr>
          <tr>
            <td>British Columbia</td>
            <td>(604) 484-4440 Vancouver</td>
          </tr>
          <tr>
            <td>Ontario</td>
            <td>
              (905) 481-2727 Hamilton
              <br /> (416) 628-8700 Toronto
            </td>
          </tr>
          <tr>
            <td>Quebec</td>
            <td>(514) 448-8484 Montreal</td>
          </tr>
        </tbody>
      </table>
    </Main>
  );
}
